module.exports = __webpack_public_path__ + "static/yadhu@3x-baeb6b470a1b418c7fc39a252f21b085.png";